import React, { useState } from "react";
import "./EngagedSection.scss";
import engagedPhoto from "./images/katerina_and_ilian.webp";
import heartsLine from "./images/hearts-line.svg";
import OnScrollAnimationWrapper from "../common/OnScrollAnimationWrapper";
import orchidImage from "./images/orchid.webp";
import bubbleImage from "./images/bubbles-up-2.svg";
import bubbleImageDown from "./images/bubbles-down-home.svg";

export default function RingsSection({ t }) {
  const [showConfirmText, setShowConfirmText] = useState(false);

  return (
    <div className="bg-base">
      <div className="overflow-hidden bg-beige engaged-section relative">
        <div className="container">
          <div className="flex flex-justify-center">
            <div className="flex flex-align-center flex-justify-center col-11 col-12-xsm col-12-md">
              <div className="col-5 col-12-xsm p-right-2 p-right-no-xsm content-engaged-section text-justify-xsm">
                <img className="m-top-12 m-bottom-2 m-top-4-xsm hearts-line" src={heartsLine} alt="rings" width="100%" height="auto" />
                <OnScrollAnimationWrapper
                  animation={"animation-slide-fade-in-down"}
                  triggerOnce={false}
                  classNameInitialState={`opacity-0 text-animation-slide-in`}
                >
                  <div className="text-lg text-md text-primary m-bottom-2">{t.presenceText}
                  </div>
                  <div className="text-lg text-md text-primary m-bottom-2">
                    {t.locationText} <span className="text-bold">{t.restaurantName}</span>
                  </div>
                  <div className="text-lg text-md text-primary m-bottom-2">
                    {t.confirmByText} <span className="text-bold">{t.confirmByDate}</span>
                  </div>
                </OnScrollAnimationWrapper>
                <div className="m-bottom-4 m-bottom-8-xsm">
                  <button className="confirm-btn btn-fluid-mobile" onClick={() => setShowConfirmText(true)}>
                    <i className="fa-solid fa-calendar-check m-right-1"></i>
                    {t.confirmBtn} <span className="hidden-xs-min">{t.confirmBtnMobile}</span>
                  </button>
                  {showConfirmText && (
                    <div className="text-lg text-md text-primary m-block-1 animation-fade-in">{t.confirmFormText} <span className="text-bold text-primary">{t.confirmFormBold}</span>{t.confirmFormEnd}</div>
                  )}
                </div>
              </div>
              <div className="col-7 col-12-xsm p-left-6 p-left-no-xsm relative order-first-xsm">
                <img className="m-top-12 m-bottom-8 m-top-6-xsm m-bottom-2-xsm" src={engagedPhoto} width="100%" height="auto" />
              </div>
            </div>
          </div>
        </div>
        <img className="orchid-image" src={orchidImage} width="100%" height="auto" />
        <img className="bubble-image-up" src={bubbleImage} width="100%" height="auto" />
        <img className="bubble-image-down" src={bubbleImageDown} width="100%" height="auto" />
      </div>
    </div>
  );
}
